import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "the-tales-of-beedle-the-bard-v1-diy-cover",
  name: "DIY Cover Tales of Beedle the Bard v1",
  nameFormatted: {
    primary: "DIY Cover",
    secondary: "Tales of Beedle the Bard v1",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
